import React from 'react';

import { Input, theme, Typography } from 'antd';

import sessionManager, { eVariableType } from '../../SessionManager';
import MenuMagazzino from './MenuMagazzino';

const { useToken } = theme;

type HeaderBarPars = {
    descrizione?: string;
    menuSelezionato: string;
};

export default function HeaderBar(par: HeaderBarPars) {
    const { token } = useToken();

    return (
        <div>
            <div
                style={{
                    height: '100px',
                    background: token.colorPrimary,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <div>
                    <img style={{ marginLeft: '25px' }} height={50} alt="" src="custom/logosocietabianco.png"></img>
                </div>
                <div style={{ verticalAlign: 'center', justifyContent: 'space-between' }}>
                    <MenuMagazzino currentMenu={par.menuSelezionato}></MenuMagazzino>
                </div>

                <div></div>
            </div>
        </div>
    );
}
